const Constants = {
	API_PUBLIC: 'https://7red1ckigi.execute-api.us-east-1.amazonaws.com/Stage/public',
	API_PRIVATE: 'https://7red1ckigi.execute-api.us-east-1.amazonaws.com/Stage/private/api'
};

export default Constants;
